import Footer from "../Footer/footer";
import MenuBar from "../Menu/menu";
import Panel from "../Panel/panel";
const Home = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
      }}
    >
      <MenuBar />
      <Panel />
      <Footer />
    </div>
  );
};

export default Home;
